import { ORDER_STATUS_BUCKET } from '@klareospace/pharos-lib-types';

export type OrderSortableColumn =
  'assignedTo.carrier.name' | 'customer.firstName' | 'eta.value' | 'requestedTimeWindow.start' | 'status';

export type StatusBucketKey = keyof typeof ORDER_STATUS_BUCKET;

export type OrderTab = 'action_required' | 'all';

export const ORDERS_TABLE_HIDDEN_COLUMNS_KEY = 'orders-table-hidden-columns';
export const ORDERS_TABLE_SHOWN_COLUMNS_KEY = 'orders-table-shown-columns';
export const ORDERS_TABLE_COLUMN_ORDER_KEY = 'orders-table-column-order';

/**
 * Column keys hidden unless opted into via `orders-table-shown-columns` (opt-in), instead of
 * `orders-table-hidden-columns` (opt-out) — keeps existing users' stored layouts untouched.
 */
export const DEFAULT_HIDDEN_COLUMNS: string[] = ['eta.value'];

/** Sentinel value for the "Unassigned" option in the orders driver filter — maps to `unassignedDriver: true`. */
export const UNASSIGNED_DRIVER_VALUE = '__unassigned__';
